import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FastPayments } from '../../_model/fast-payments.model';

@Component({
  selector: 'app-fast-payments-table',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './fast-payments-table.component.html',
  styleUrl: './fast-payments-table.component.scss'
})
export class FastPaymentsTableComponent {
  @Input() payment: FastPayments;
  @Input() titleAsH1 = false;
  content: {
    type: string;
    price: string;
    units: string;
    taxFee: string;
    postalFee: string;
    administrativeFee: string;
    priceSum: string;
  };
  isMobile: boolean;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.get('FAST_PAYMENTS.CART_LIST').subscribe({
      next: (content: any) => (this.content = content)
    });

    this.checkIsMobile();
  }

  feeChecker(fee: string): boolean {
    return this.payment.items.some(el => el[fee] !== null && el[fee] !== undefined);
  }

  @HostListener('window:resize', ['$event'])
  checkIsMobile() {
    if (window.innerWidth <= 576) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
}
